import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getLocalidades, deleteLocalidad } from "../../../../api/localidad";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";

function getData(localidades) {
  return localidades.map(localidad => ({
    name: localidad.fullName,
    createdAt: localidad.createdAt,
    id: localidad._id
  }));
}

export default function LocalidadesPage() {
  const [data, setData] = useState([]);
  const [localidad, setLocalidad] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  function buttonFormatter(cell) {
    const elem = data.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Editar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-city/" + elem.id)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {user?.isAdmin && (
          <>
            <Tooltip title="Borrar">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setLocalidad(elem);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "name", text: "Nombre", sort: true },
    { dataField: "id", text: "", formatter: buttonFormatter, headerStyle: { width: '150px' } },
  ];

  useEffect(() => {
    getLocalidades()
      .then((res) => {
        setData(getData(res.data));
        setRefresh(false);
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las ciudades.",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Ciudades">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary text-white"
              onClick={() => history.push("/edit-city")}
            >
              Añadir
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table data={data} columns={columns} />

          <ConfirmDialog
            title={"Seguro que quieres eliminar esta ciudad?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteLocalidad(localidad.id)
                .then((res) => {
                  alertSuccess({
                    title: "Eliminado!",
                    customMessage: "Ciudad eliminada correctamente.",
                  });
                  setRefresh(true);
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se ha podido eliminar la ciudad.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
